// Uno script che nasconde il bottone di aggiungi al carrello nella pagina del prodotto
// Nasconde solo il bottone della pagina, solo su prodotti personalizzabili
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {
    const eligibleCollectionId = 667245511004;
    const product = window.product || {};

    const isEligible =
        Array.isArray(product.collections) &&
        product.collections.some((c) => c.id == eligibleCollectionId);

    if (!isEligible) return;

    const productSection = document.querySelector(".single-product-details.w-100");
    if (!productSection) return;

    const hideAddToCart = () => {
        const addToCartWrapper = productSection.querySelector(".add-to-cart__wrapper");
        if (addToCartWrapper) {
            addToCartWrapper.style.setProperty("display", "none", "important");
        }
    };

    // Nasconde subito se già presente
    hideAddToCart();

    // Osserva modifiche future (re-render del tema)
    const observer = new MutationObserver(() => hideAddToCart());
    observer.observe(productSection, {
        childList: true,
        subtree: true,
    });
});
